export default "__VITE_ASSET__6f05721b__"